import axios from "axios";
import { NO_PROPOSAL_ALERTS } from "@utils";

export const sendProposalAlert = async (projectName, category, errorMessage, versionData) => {
  try {
    const instance = axios.create();
    delete instance.defaults.headers.common['Authorization'];
    instance.defaults.headers.put["Content-Type"] = "application/json";
    
    
    const linkMatch = location.href.match(/\/proposal\/([^/]+)\/([^/]+)\/([^/?]+)(?:\/([^/?]+))?/);
    const [, workspaceUuid] = linkMatch;
    
    const res = await instance.request({
      method: "POST",
      url: import.meta.env.APP_SLACK_WEBHOOK_URL,
      data: JSON.stringify({
        text: "🚨 Proposal alarm",
        attachments: [
          {
            color: "danger",
            footer: "Apropo.io Proposal Monitoring",
            ts: Date.now(),
            mrkdwn_in: ["text", "fields"],
            fields: [
              {
                "title": "Project",
                "value": projectName,
                "short": true,
              },
              {
                "title": "Workspace uuid",
                "value": workspaceUuid,
                "short": true,
              },
              ...(
                versionData
                  ? [
                    {
                      "title": "Version",
                      "value": `${versionData.key} - "${versionData.name}"`,
                      "short": true,
                    },
                    {
                      "title": "Structure version",
                      "value": versionData.v,
                      "short": true,
                    },
                  ] : []
              ),
              {
                "title": "Link",
                "value": `<${location.href}?${NO_PROPOSAL_ALERTS}=true|Open proposal>`,
                "short": true,
              },
              {
                "title": "Step",
                "value": category,
                "short": true,
              },
              {
                "title": "Error message",
                "value": "```" + errorMessage.toString().slice(0, 256) + "```",
              }
            ]
          }
        ]
      })
    })
    
    console.log(res);
    
  } catch (e) {
    console.error(e);
  }
};
